const SITE_URL = "https://www.wags.com";
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.jpg`;
type SeoMeta = {
    title: string;
    description: string;
    url: string;
    image?: string;
    imageMimeType?: string;
    video?: { url: string; width: number; height: number };
    type?: string;

    noindex?: boolean;
    nofollow?: boolean;
};

export function seoMeta({
    title,
    description,
    url,
    image,
    imageMimeType,
    video,
    type,
    noindex,
    nofollow,
}: SeoMeta) {
    const ogImage = image ?? DEFAULT_OG_IMAGE;
    const ogType = type ?? "website";
    const fullUrl = url.startsWith("http") ? url : `${SITE_URL}${url}`;

    return {
        meta: [
            { title },
            { name: "description", content: description },
            ...(noindex
                ? [
                      {
                          name: "robots",
                          content: nofollow ? "noindex, nofollow" : "noindex",
                      } as const,
                  ]
                : []),
            { property: "og:title", content: title },
            { property: "og:description", content: description },
            { property: "og:type", content: ogType },
            { property: "og:url", content: fullUrl },
            { property: "og:image", content: ogImage },
            { property: "og:image:width", content: "1200" },
            { property: "og:image:height", content: "630" },
            {
                property: "og:image:type",
                content: imageMimeType ?? "image/jpeg",
            },
            ...(video
                ? [
                      { property: "og:video", content: video.url },
                      { property: "og:video:secure_url", content: video.url },
                      { property: "og:video:type", content: "video/mp4" },
                      {
                          property: "og:video:width",
                          content: String(video.width),
                      },
                      {
                          property: "og:video:height",
                          content: String(video.height),
                      },
                  ]
                : []),
            { name: "twitter:card", content: "summary_large_image" },
            { name: "twitter:title", content: title },
            { name: "twitter:description", content: description },
            { name: "twitter:image", content: ogImage },
        ],
        links: [{ rel: "canonical", href: fullUrl }],
    };
}
